<wilson-working-time-section-wrapper
  [title]="'page.working_time.overtimes.title' | translate"
>
  <ion-col size="6">
    <wilson-worktime-metrics-card
      [header]="
        'page.working_time.overtimes.overtime-account-balance'
          | translate: { monthYear: overtimeMonthYearLabel() }
      "
      [values]="[overtimeStats().overtimeByYear]"
      [unit]="PayrollUnitName.Hour"
      [loading]="loadingSignal()"
    />
  </ion-col>
  <ion-col size="6">
    <wilson-worktime-metrics-card
      [header]="
        'page.working_time.overtimes.compensated-overtime-current-month'
          | translate
      "
      [values]="[overtimeStats().overtimeCompensationByYear]"
      [unit]="PayrollUnitName.Hour"
      [loading]="loadingSignal()"
    />
  </ion-col>
  <ion-col size="6">
    <wilson-worktime-metrics-card
      [header]="
        'page.working_time.overtimes.overtime-current-month' | translate
      "
      [values]="[overtimeByCurrentMonth()]"
      [unit]="PayrollUnitName.Hour"
      [loading]="loadingWorktimeStats()"
    />
  </ion-col>
  @for (data of overtimeStats().restOfOvertimesByYear; track data.name) {
    <ion-col size="6">
      <wilson-worktime-metrics-card
        [header]="
          data.translatedName +
          ' ' +
          ('general.balance'
            | translate: { monthYear: overtimeMonthYearLabel() })
        "
        [values]="[data.value]"
        [unit]="PayrollUnitName.Hour"
        [loading]="loadingSignal()"
      />
    </ion-col>
  }
</wilson-working-time-section-wrapper>
